import { Alert, AlertDescription, AlertIcon, Spinner } from "@chakra-ui/react";

import type { PaymentConfirmationState } from "../../hooks/usePaymentConfirmation";

export default function PaymentConfirmationBanner({ state }: { state: PaymentConfirmationState }) {
  if (state === "waiting") {
    return (
      <Alert status="info" borderRadius="md" mb={4}>
        <Spinner size="sm" mr={3} />
        <AlertDescription>
          Czekamy na potwierdzenie płatności z Przelewy24. Zamówienie zaktualizuje się automatycznie.
        </AlertDescription>
      </Alert>
    );
  }
  if (state === "timeout") {
    return (
      <Alert status="warning" borderRadius="md" mb={4}>
        <AlertIcon />
        <AlertDescription>
          Płatność jest jeszcze przetwarzana. Potwierdzenie otrzymasz mailem — możesz też odświeżyć
          stronę za chwilę.
        </AlertDescription>
      </Alert>
    );
  }
  return null;
}
